import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import axios from "axios";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/swiper-bundle.css";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";

const Main = ({ isPopup }) => {
  const location = useLocation();

  const [banners, setBanners] = useState([]);
  const [news, setNews] = useState([]);
  const [player, setPlayer] = useState(null);

  const [isPlaying, setIsPlaying] = useState(false);

  const [popups, setPopups] = useState([]);

  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
	
	const titleElement = document.getElementsByTagName("title")[0];
	titleElement.innerHTML = `아소비메인`;
	
    const fetchData = async () => {
      // 배너 데이터 가져오기
      const responseBanners = await axios.get("/main");

      const sortedBanners = responseBanners.data.banners.sort(
        (a, b) => a.sort - b.sort
      );

      setBanners(sortedBanners);
      console.log(sortedBanners);

      // 뉴스 데이터 가져오기
      const responseNews = await axios.get("/boards");

      // gubun이 'BB01'인 뉴스만 필터링
      if (responseNews.data.length > 0) {
        const filteredNews = responseNews.data.filter(
          (item) => item.gubun === "BB01"
        );

        const sortedNews = filteredNews.sort(
          (a, b) => new Date(b.regDate) - new Date(a.regDate)
        );
        setNews([sortedNews[0]]); // 가장 최근 뉴스만 배열로 설정
      } else {
        setNews([]); // 뉴스가 없을 경우
      }
    };

    fetchData();
	
	const fetchPopup = async () => {
	  try {
	    const response = await axios.get("/bplist");

	    // 현재 시간을 가져오기 (한국 표준시)
	    const currentDate = new Date();
	    const formattedCurrentDate = currentDate
	      .toISOString()
	      .replace("T", " ")
	      .substring(0, 16); // "YYYY-MM-DD HH:mm" 형식

	    const filteredPopups = response.data.filter((popup) => {
	      // 팝업 종료일과 시간, 분을 결합
	      const popEndDateTime = new Date(
	        `${popup.popEnd} ${popup.popEhour}:${popup.popEmin}`
	      );

	      const isClosedDate = localStorage.getItem(`popup_${popup.idx}`); // 저장된 날짜
	      const shouldShowPopup =
	        isClosedDate !== formattedCurrentDate.substring(0, 10); // 오늘과 다르면 팝업 표시

	      return (
	        popup.gubun === "PP01" &&
	        popEndDateTime >= currentDate && // 현재 시간과 비교
	        shouldShowPopup
	      );
	    });

	    setPopups(filteredPopups);
	  } catch (error) {
	    console.error("Error fetching banners:", error);
	  }
	};

    fetchPopup();

    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
      const newPlayer = new window.YT.Player("u_player", {
        height: "560",
        width: "315",
        videoId: "oYLIXq4RQ_c",
      });
      setPlayer(newPlayer);
    };

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });
  }, [location]);

  const handlePlay = () => {
    if (player) {
      player.playVideo();
      setIsPlaying(true); // 비디오가 재생되면 상태 업데이트
    }
  };

  const popupClose = (index, popupId) => {
    const isChecked = document.getElementById(`chkbox${index}`).checked;

    if (isChecked) {
      const currentDate = new Date().toISOString().split("T")[0]; // YYYY-MM-DD 형식
      // 로컬 스토리지에 오늘 날짜를 저장
      localStorage.setItem(`popup_${popupId}`, currentDate);
    }

    // 팝업을 상태에서 제거
    setPopups((prevPopups) => prevPopups.filter((_, i) => i !== index));
  };

  //이미지가 로드 된후에 form이 뜰 수 있도록 설정
  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <div>
      <ScrollAnimation />
      <section id="index" className={isPopup ? "onPopup" : ""}>
        <div className="visual">
          <div className="slider">
            <div className="swiper-slide">
              <Swiper
                modules={[Autoplay, Navigation, Pagination]}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                loop={true}
                slidesPerView={1}
                navigation={true}
                pagination={{ clickable: true }}
                className="swiper-container"
              >
                {banners.length > 0 ? (
                  banners.map((banner) => (
                    <SwiperSlide key={banner.bnIdx}>
                      <a href={banner.url1} target={banner.target}>
                        <div className="img">
                          <img
                            src={`/static/DATA/banner/${banner.file1}`}
                            className="mainimg"
                            alt={banner.title}
                          />
                          <img
                            src={`/static/DATA/banner/${banner.file1}`} // 동일한 이미지 사용
                            className="mainbg"
                            alt={banner.title}
                          />
                        </div>
                        {/* <div className="con">
                          <strong>{banner.title}</strong>
                          <span>{banner.title_sub}</span>
                        </div> */}
                      </a>
                    </SwiperSlide>
                  ))
                ) : (
                  <SwiperSlide>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_mainvisual.png"
                        className="mainimg"
                        alt=""
                      />
                      <img
                        src="../custom-resources/img/img_mainvisual.png"
                        className="mainbg"
                        alt=""
                      />
                    </div>
                    <div className="con">
                      <strong></strong>
                      <span></span>
                    </div>
                  </SwiperSlide>
                )}
              </Swiper>
            </div>
          </div>
        </div>

        <div className="education">
          <div className="wrap">
            <div className="vod">
              <div
                className="img"
                id="play"
                onClick={handlePlay}
                style={isPlaying ? { opacity: 0, zIndex: 1 } : {}}
              >
                <i></i>
                <img src="../custom-resources/img/TVC_231011.png" alt="" />
              </div>
              <div className="iframe">
                <div id="u_player"></div>
              </div>
            </div>

            <div className="title init">
              아소비가 TV에 떴다! <br className="mo-view" />
              <p>아소비 NEW CF 영상 공개!</p>
            </div>
            <div className="cont">
              <div className="txt init">
                건강한 공부, 즐거운 공부, 행복한 공부
                <br />
                <br />
                듣기만 해도 신나는 아소비 댄스처럼 공부도 재미있게!
                <br />
                지금 TV와 온라인에서 새로워진 아소비 광고를 만나 보세요!
              </div>
            </div>

            <div className="title init">
              우리아이 <p>학습생명력</p>
              <br className="mo-view" /> 어떻게 키워주시나요?
            </div>
            <div className="cont">
              <div className="tit init">
                스스로 즐겁게 공부하는 힘! <br />
                학습생명력은 아소비에서부터 시작합니다.
              </div>
              <div className="txt init">
                5세부터 9세까지는 지식을 주입하는 교육이 아닌
                <br className="mo-view" />
                ‘스스로 즐겁게 공부하는 힘’을
                <br className="mo-view" />
                알게 해 주는 것이 중요합니다.
                <br />
                그래서 아소비는 본격적인 학습이 시작되는
                <br className="mo-view" />
                10세 전인 <strong>5~9세에 학습의 길을 준비</strong>해 줍니다.
              </div>
              <div className="img init">
                <dl>
                  <dt>
                    <a href="/philosophy#brainshower">
                      <img
                        src="../custom-resources/img/img_maineducation01.png"
                        alt=""
                      />
                    </a>
                  </dt>
                  <dd>
                    <strong>브레인 샤워</strong>
                    <span>잘못된 교육으로 찌든 뇌를 깨끗이</span>
                  </dd>
                </dl>
                <dl>
                  <dt>
                    <a href="/philosophy#happy">
                      <img
                        src="../custom-resources/img/img_maineducation02.png"
                        alt=""
                      />
                    </a>
                  </dt>
                  <dd>
                    <strong>쾌 학습</strong>
                    <span>유쾌, 상쾌, 통쾌한 학습</span>
                  </dd>
                </dl>
                <dl>
                  <dt>
                    <a href="/philosophy#running">
                      <img
                        src="../custom-resources/img/img_maineducation03.png"
                        alt=""
                      />
                    </a>
                  </dt>
                  <dd>
                    <strong>걷는 교육</strong>
                    <span>조금씩 천천히, 맞춤 교육</span>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div className="program">
          <div className="wrap">
            <div className="title init">아소비 프로그램</div>
            <div className="text init">
              과연 배움이 꿀처럼 달까요? <br />
              아소비를 만난 아이들은 배움이 즐거워집니다.
            </div>
            <div className="cont init">
              <ul>
                <li>
                  <a href="/process_basic">
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_mainprogram01.png"
                        alt=""
                      />
                    </div>
                    <div className="tit">아소비 유치 프로그램</div>
                    <div className="ico">
                      <img src="../custom-resources/img/img_zubi.png" alt="" />
                    </div>
                  </a>
                </li>
                <li>
                  <a href="/program_elementary">
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_mainprogram02.png"
                        alt=""
                      />
                    </div>
                    <div className="tit">아소비 초등 프로그램</div>
                    <div className="ico">
                      <img src="../custom-resources/img/img_kkur.png" alt="" />
                    </div>
                  </a>
                </li>
              </ul>
              <div className="icon">
                <i className="asak"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="special">
          <div className="wrap">
            <div className="title">아소비 특별 프로그램</div>
            <div className="text">
              아소비에서만 만날 수 있는 특별 프로그램으로 <br />
              우리 아이는 더 특별해집니다.
            </div>
            <div className="cont">
              <ul>
                <li>
                  <a href="/program_learning">
                    <div className="txt">
                      발달 수준에 맞는 학습 능력을 높여주는
                    </div>
                    <div className="tit">두뇌 톡톡 프로그램</div>
                  </a>
                </li>
                <li>
                  <a href="/program_language">
                    <div className="txt">술술 읽고 쏙쏙 이해하는</div>
                    <div className="tit">언어 톡톡 프로그램</div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {news.length > 0 ? (
          <div key={news[0].idx} className="news">
            <div className="wrap">
              <div className="tit">아소비 소식</div>
              <div className="txt">
                <Link to={`/news_detail/${news[0].idx}`}>{news[0].title}</Link>
              </div>
            </div>
          </div>
        ) : (
          <div>등록된 소식이 없습니다.</div>
        )}
      </section>
      <div id="popup">
        {popups.map((popup, index) => (
          <div className="popup" id={`divpopup${index}`} key={popup.idx}>
            <div className="cont">
              <a href={popup.url1} target={popup.target}>
                <img
                  src={`/static/DATA/banner/${popup.file1}`}
                  alt="Popup"
                  onLoad={handleImageLoad} // 이미지 로드 시 호출
                />
              </a>
            </div>
            {imageLoaded && (
              <form name={`notice_form${index}`} action="">
                <div className="ctrl">
                  <label className="today">
                    <input
                      type="checkbox"
                      name="chkbox"
                      id={`chkbox${index}`}
                      value="checkbox"
                    />
                    <span>오늘 하루동안 열지 않기</span>
                  </label>
                  <a
                    href="#"
                    className="close"
                    onClick={() => popupClose(index, popup.idx)}
                  >
                    <p>[닫기]</p>
                  </a>
                </div>
              </form>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Main;
